import { render, staticRenderFns } from "./business.vue?vue&type=template&id=a39e4aac&"
import script from "./business.vue?vue&type=script&lang=js&"
export * from "./business.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BusinessHeader: require('/home/runner/work/webpage/webpage/components/business/header/header.vue').default,BusinessData: require('/home/runner/work/webpage/webpage/components/business/data/data.vue').default,BusinessHowItWorks: require('/home/runner/work/webpage/webpage/components/business/how-it-works/how-it-works.vue').default,HomeFeaturedIn: require('/home/runner/work/webpage/webpage/components/home/featured-in/featured-in.vue').default,BusinessWhitepaper: require('/home/runner/work/webpage/webpage/components/business/whitepaper/whitepaper.vue').default,BusinessMembersGraph: require('/home/runner/work/webpage/webpage/components/business/members-graph/members-graph.vue').default,BaseTestimonialsImage: require('/home/runner/work/webpage/webpage/components/base/testimonials-image/testimonials-image.vue').default,BusinessCalendly: require('/home/runner/work/webpage/webpage/components/business/calendly/calendly.vue').default,BusinessContactForm: require('/home/runner/work/webpage/webpage/components/business/contact-form/contact-form.vue').default,AreaFaqs: require('/home/runner/work/webpage/webpage/components/area/faqs/faqs.vue').default,BaseFooter: require('/home/runner/work/webpage/webpage/components/base/footer/footer.vue').default})
